<template>
  <div class="orderList">
    <IndexHeader />
    <div class="orgTopHeaderBox">
      <div class="list-bg">
        <div class="bg-content">
          <div class="m-list"><span class="list-font">订单管理</span></div>
          <div class="m-content">
            <div class="m-left">
              <span>课程编号：{{ listData.course.courseId }}</span>
            </div>
            <div class="m-left">
              <span class="className"
                >课程名称：{{ listData.course.courseName }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="signDetailsBox" style="display: none">
      <div class="signDetails">
        <div class="signTop clear">
          <div class="leftTitle">签到详情</div>
          <div class="close"><span class="iconfont"></span></div>
        </div>
        <div class="effectiveduration">
          有效时长：<span>0</span>小时<span>0</span>分钟
        </div>
        <div class="details"></div>
      </div>
    </div>
    <div class="list-list">
      <div class="selectStatus">
        <span
          :class="query.type == 1 ? 'orderStatus actived' : 'orderStatus'"
          @click="bindTab(1)"
          >线上支付订单({{ listData.onlineList.length }})</span
        >
        <span
          :class="query.type == 2 ? 'orderStatus actived' : 'orderStatus'"
          @click="bindTab(2)"
          >线下支付订单({{ listData.offlineList.length }})</span
        >
        <span
          :class="query.type == 3 ? 'orderStatus actived' : 'orderStatus'"
          @click="bindTab(3)"
          >已取消({{ listData.cancelList.length }})</span
        >
        <span>
          <div class="list-middle">
            <div class="middle-button">
              <div class="bgs pi ac" @click="handleExport">导出全部订单</div>
              <div class="bgs pi ac" @click="handleImport">批量导入订单</div>
            </div>
          </div>
        </span>
      </div>
      <div class="borders"></div>
      <div class="result">
        <div class="list-content" v-for="item in listData.data" :key="item.value">
          <div class="list-top">
            <span class="order-number order-date"
              >订单号：{{ item.orderSn }}</span
            >
            <span class="order-date order-date"
              >报名时间：{{ item.createTime }}</span
            >
          </div>
          <div class="list-bottom">
            <span class="name">{{ item.nickName }}</span>
            <span class="phone">{{ item.phonenumber }}</span>
            <span class="money">{{ item.money }}</span>
            <span class="payFor">个人报名</span>
            <span class="paytype">{{ item.payType }}</span>
            <span class="payStatus">{{ item.orderStatus }}</span>
            <span class="teikets">
              <span @click="openBill(item.orderSn)">发票信息</span>
              <span @click="confirmOfflinePayClick(item.orderSn)" v-if="item.orderStatus == '待付款'">线下支付</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 发票信息 -->
    <div class="bills" v-show="billFcStatus">
      <div class="nameListBox">
        <div class="topHeader clear">
          <div class="title">发票信息</div>
          <div class="close" @click="billFcStatus = false">
            <span class="iconfont"></span>
          </div>
        </div>
        <div class="course-content">
          <div class="tearcherList">
            <div><span>发票抬头:</span>{{ billData.billName }}</div>
            <div><span>单位税号:</span>{{ billData.taxCode }}</div>
            <div><span>注册地址:</span>{{ billData.billAddress }}</div>
            <div><span>注册电话：</span>{{ billData.billPhone }}</div>
            <div><span>开户银行：</span>{{ billData.bank }}</div>
            <div><span>银行账号：</span>{{ billData.bankAccount }}</div>
            <div><span>收件姓名:</span>{{ billData.collectName }}</div>
            <div><span>收件电话:</span>{{ billData.collectPhone }}</div>
            <div><span>收件地址：</span>{{ billData.collectAddress }}</div>
            <div><span>收件邮箱:</span>{{ billData.collectEmail }}</div>
          </div>
        </div>
      </div>
    </div>
    <!--导入-->
    <el-dialog
      :title="upload.title"
      v-model="upload.open"
      width="400px"
      append-to-body
    >
      <el-upload
        ref="uploadRef"
        :limit="1"
        accept=".xlsx, .xls"
        :headers="upload.headers"
        :action="upload.url"
        :disabled="upload.isUploading"
        :on-progress="handleFileUploadProgress"
        :on-success="handleFileSuccess"
        :auto-upload="false"
        drag
      >
        <el-icon class="el-icon--upload"><upload-filled /></el-icon>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <template #tip>
          <div class="el-upload__tip text-center">
            <span>仅允许导入xls、xlsx格式文件。</span>
            <el-link
              type="primary"
              :underline="false"
              style="font-size: 12px; vertical-align: baseline"
              @click="importTemplate"
              >下载模板</el-link
            >
          </div>
        </template>
      </el-upload>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="submitFileForm" :disabled="uploadingExcel">确 定</el-button>
          <el-button @click="upload.open = false">取 消</el-button>
        </div>
      </template>
    </el-dialog>
    <!-- 添加付款单号输入框 -->
    <el-dialog title="167" v-model="payOrderOpen" width="500px" append-to-body>
      <el-form :model="payOrderParams" ref="payOrder" label-width="auto">
        <el-form-item label="付款单号" prop="remark">
          <el-input v-model="payOrderParams.remark" placeholder="请输入付款单号" onkeyup="value=value.replace(/[^\d]/g,0)"/>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="confirmPayOrderNumber">确 定</el-button>
          <el-button @click="cancel">取 消</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
// 首页顶部导航栏
import IndexHeader from "../../components/IndexHeader/TopBar";
// 获取token
import { courseOrderList, invoice, offlinePayment } from "../../server/jigou/order";
import { requestToken } from '../../common/js/request_token.js'

import { ref, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getCurrentInstance } from 'vue'
import { downLoadFile } from "../../server/base";
const route = useRoute();
const { proxy } = getCurrentInstance();
const query = reactive({
  courseId: route.query.id,
  type: 1,
});
//线下支付
const payOrderParams = reactive({
    orderSn: "",
    remark:null
});
//正在上传Excel时 确定按钮无法点击 解决点击上传多个问题
const uploadingExcel = ref(false);
const payOrderOpen = ref(false);
const billFcStatus = ref(false);
const listData = reactive({
  data: [],
  onlineList: [],
  offlineList: [],
  cancelList: [],
  course: {},
});
/*** 批量导入订单 */
const upload = reactive({
  // 是否显示弹出层（批量导入）
  open: false,
  // 弹出层标题（批量导入订单）
  title: "",
  // 是否禁用上传
  isUploading: false,
  // 是否更新已经存在的用户数据
  updateSupport: 0,
  // 设置上传的请求头部let token = requestToken();
  headers: { Authorization: "Bearer " + "" + requestToken() },
  // 上传的地址
  url: process.env.VUE_APP_API_BASE_URL + "bus/order/importOrderData?courseId=" + query.courseId,
});
//获取订单列表
async function getOrderList() {
  let res = await courseOrderList(query);
  if (res != false) {
    listData.course = res.course;
    listData.onlineList = res.onlineList;
    listData.offlineList = res.offlineList;
    listData.cancelList = res.cancelList;
    listData.data = res.onlineList;
  }
}
getOrderList();
function bindTab(e) {
  query.type = e;
  if (e == 1) {
    listData.data = listData.onlineList;
  }
  if (e == 2) {
    listData.data = listData.offlineList;
  }
  if (e == 3) {
    listData.data = listData.cancelList;
  }
}
const billQuery = reactive({
  orderSn: "",
});
const billData = ref({});
//发票浮层
async function openBill(id) {
  billQuery.orderSn = id;
  let res = await invoice(billQuery);
  if (res != false) {
    billData.value = res;
    billFcStatus.value = true;
  }
}
/** 导入按钮操作 */
function handleImport() {
  upload.title = "导入订单";
  upload.open = true;
}
/** 下载模板操作 */
function importTemplate() {
    downLoadFile("/bus/order/importTemplate","","模板")
};
/**文件上传中处理 */
const handleFileUploadProgress = (event, file, fileList) => {
  upload.isUploading = true;
};
/** 文件上传成功处理 */
const handleFileSuccess = (response, file, fileList) => {
  upload.open = false;
  uploadingExcel.value = false;
  upload.isUploading = false;
  proxy.$refs["uploadRef"].handleRemove(file);
  proxy.$alert("<div style='overflow: auto;overflow-x: hidden;max-height: 70vh;padding: 10px 20px 0;'>" + response.msg + "</div>", "导入结果", { dangerouslyUseHTMLString: true });
  getOrderList();
};
/** 提交上传文件 */
function submitFileForm() {
  uploadingExcel.value = true;
  proxy.$refs["uploadRef"].submit();
};
/** 导出按钮操作 */
function handleExport() {
  downLoadFile("/bus/order/export",query,"订单列表")
}

/** 线下付款按钮事件 */
async function confirmOfflinePayClick(orderNum) {
  payOrderOpen.value = true;
  payOrderParams.orderSn = orderNum;
}
// 取消按钮
function cancel() {
  payOrderOpen.value = false;
}
/** 线下付款弹窗 确认按钮 */
async function confirmPayOrderNumber() {
  let res =  await offlinePayment(payOrderParams);
  if (res != false) {
    proxy.$modal.msgSuccess("确认支付成功");
    payOrderOpen.value = false;
    getOrderList();
  }
}
</script>
<style scoped>
.orgTopHeaderBox {
  margin-top: 64px;
}
.list-middle {
  height: 26px;
  background: rgba(0, 0, 0, 0);
}
.list-middle .middle-button {
  width: 450px;
  display: flex;
  justify-content: space-evenly;
}
.list-middle .middle-button .pi {
  margin-top: 0px;
}
.list-middle .middle-button .ac {
  float: none;
  margin-right: 0px;
  cursor: pointer;
  color: #fff;
}
</style>